import type { IAccordionItem } from "~/aihd-base-nuxt/types/components/accordion.type";
import type { TCycle } from "../types";

export const usePricingData = (isEnterprise?: boolean, cycle?: TCycle, backupStorage?: string) => {
    const { t } = useI18n();

    const faqFirstRow: IAccordionItem[] = [
        {
            title: t("pages_pricing_faq_q1"),
            content: t("pages_pricing_faq_a1"),
        },
        {
            title: t("pages_pricing_faq_q2"),
            content: t("pages_pricing_faq_a2"),
        },
        {
            title: t("pages_pricing_faq_q3"),
            content: t("pages_pricing_faq_a3"),
        },
        {
            title: t("pages_pricing_faq_q4"),
            content: t("pages_pricing_faq_a4"),
        },
        {
            title: t("pages_pricing_faq_q5"),
            content: t("pages_pricing_faq_a5"),
        },
    ];

    const faqSecondRow: IAccordionItem[] = [
        {
            title: t("pages_pricing_faq_q6"),
            content: t("pages_pricing_faq_a6"),
        },
        {
            title: t("pages_pricing_faq_q7"),
            content: t("pages_pricing_faq_a7"),
        },
        {
            title: t("pages_pricing_faq_q8"),
            content: t("pages_pricing_faq_a8"),
        },
        {
            title: t("pages_pricing_faq_q9"),
            content: t("pages_pricing_faq_a9"),
        },
        {
            title: t("pages_pricing_faq_q10"),
            content: t("pages_pricing_faq_a10"),
        },
    ];

    const freeWatermarkFeature = `<p class=' mb-4 xl:mb-0 xl:my-8'>${t("pages_pricing_watermark_free")}</p>`;
    const backupStorageFeature =
        backupStorage === "pages_pricing_unlimited"
            ? `<p class='mb-4 xl:mb-0 xl:my-8'>${t("pages_pricing_unlimited")}</p>`
            : `<p class='mb-4 xl:mb-0 xl:my-8'>${backupStorage}${t("pages_pricing_backup_storage")}</p>`;

    const freeRenovationFeature = `<div class="bg-gradient-orange w-fit mx-auto mb-4 xl:mb-0 xl:my-8"><p class="bg-gray-950 rounded-full px-2 py-1">${t(
        "pages_pricing_free_renovation"
    )}</p></div>`;
    const rolloverFeature = `<div class="bg-gradient-orange w-fit mx-auto mb-4 xl:mb-0 xl:my-8"><p class="bg-gray-950 rounded-full px-2 py-1">${t(
        "pages_pricing_unused_credits_rollover"
    )}</p></div>`;
    const subAccountManagementFeature = `<p class='mb-4 xl:mb-0 xl:my-8'>${t(
        "pages_pricing_subAccount_management"
    )}</p>`;
    const apiAccessFeature = `<p class='mb-4 xl:mb-0 xl:my-8'>  ${t("pages_pricing_api_access")} </p>`;

    const enterpriseYearly = {
        contents: [
            rolloverFeature,
            freeRenovationFeature,
            freeWatermarkFeature,
            backupStorageFeature,
            subAccountManagementFeature,
            apiAccessFeature,
            {
                type: "link",
                link: "/b2b",
                text: t("pages_pricing_explore_more_features"),
            },
        ],
    };

    const enterpriseMonthly = {
        contents: [
            rolloverFeature,
            freeWatermarkFeature,
            backupStorageFeature,
            subAccountManagementFeature,
            apiAccessFeature,
            {
                type: "link",
                link: "/b2b",
                text: t("pages_pricing_explore_more_features"),
            },
        ],
    };

    const personalYearly = {
        contents: [rolloverFeature, freeRenovationFeature, freeWatermarkFeature, backupStorageFeature],
    };

    const personalMonthly = {
        contents: [freeWatermarkFeature, backupStorageFeature],
    };

    const currentPlanFeatures = computed(() => {
        if (isEnterprise && cycle === "yearly") return enterpriseYearly;
        if (isEnterprise && cycle === "monthly") return enterpriseMonthly;
        if (cycle === "yearly") return personalYearly;
        if (cycle === "monthly") return personalMonthly;
    });

    return { faqFirstRow, faqSecondRow, currentPlanFeatures: currentPlanFeatures.value };
};
